export { default } from './TimelineDot';

export { default as timelineDotClasses } from './timelineDotClasses';
export * from './timelineDotClasses';
